import React, { useEffect, useState } from 'react';
import { Card, Button } from 'antd';
import { PurchaseOrderService } from '@gtpl/shared-services/procurement';
import {
    AllPoDetailsInfo,
    // FactoriesInput,
    PoDataModel,
    PoRequest,

    // UnitsOfWeightInput,
} from '@gtpl/shared-models/procurement-management';
import { PrinterOutlined } from '@ant-design/icons'
import { CrrencySymbols, FactoriesInput } from '@gtpl/shared-models/sale-management';

import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { ExporterDataInput } from '@gtpl/shared-models/logistics';
import { GlobalStatus, UomEnum } from '@gtpl/shared-models/common-models';
import { useLocation, useParams } from 'react-router-dom';
let converter = require('number-to-words');
import { ToWords } from 'to-words';

var convert = require('decimal-number-to-words');
import { numberToWords } from 'amount-to-words'
import moment from 'moment';
import './po-print.css';
import logo from './bmr-logo.png';
/* eslint-disable-next-line */
export interface PoPrintProps {
    poId: number;
    printOrder: () => void
}

export function PoPrint(props: PoPrintProps) {
    const poService = new PurchaseOrderService();
    const [PoDataModel, PoItemsCreateDetail] = useState<AllPoDetailsInfo>();
    const [poDataForPrint, setPoDataForPrint] = useState<any>();
    
    const [loading, setLoading] = useState(true);
    let totalTaxSum = 0;
    let sizeRequired;
    let totalQuantity =0;
    let sgst = 0;
    let cgst = 0;
    let TotalAmount = 0;
    let cal = 0
    let Totalsum = 0
    // let finalCalculation = 0

    // let location = useLocation();
    // let  { poId } = useParams<{poId}>();
    console.log(location);
    useEffect(() => {
        getData(props.poId);
    }, [])
    useEffect(() => {
        getAdditionalPoInfo(props.poId);
    }, [])
    let totalAmount = 0;
    const getData = (poId) => {
        const reqObj = new PoRequest(poId);
        poService
            .GetPoDataDetailsForPoId(reqObj)
            .then((res) => {
                if (res.status) {
                    console.log(res.data);
                    PoItemsCreateDetail(res.data);
                    console.log(PoDataModel?.poItems[0])
                } else {
                    if (res.intlCode) {
                        PoItemsCreateDetail(undefined);
                        AlertMessages.getErrorMessage(res.internalMessage);
                    } else {
                        AlertMessages.getErrorMessage(res.internalMessage);
                    }
                }
            })
            .catch((err) => {
                AlertMessages.getErrorMessage(err.message);
                PoItemsCreateDetail(undefined);
            });
    }; //deliveryAddress
    let addressDetails = ExporterDataInput;
    const poData = addressDetails.find(
        (item) => item.value == PoDataModel?.poItems[0]?.factoryId
    );

    let exporterDetails = ExporterDataInput;
    const exporterData = exporterDetails.find((item) => 
      PoDataModel?.unitinfo?.unitcodeId === 1 ? item.value === 26 : item.value === 27
    );
    
    console.log(PoDataModel?.unitinfo?.unitcodeId,"unitId")
    console.log(exporterData,"exporterData")

    const getAdditionalPoInfo = (poId) => {
        // const req=new SoFormSdfPrintDto()
        poService.getPurchaseOrderDetailsForPrints(new PoRequest(poId)).then(res => {
            if (res.status) {
                setPoDataForPrint(res.data)
            }
        })
    }
    
    // const printOrder = () => {
    //     const printableElements = document.getElementById('printme').innerHTML;
    //     const orderHTML = '<html><head><title></title></head><body>' + printableElements + '</body></html>'
    //     const oldPage = document.body.innerHTML;
    //     document.body.innerHTML = orderHTML;
    //     window.print();
    // }

    const convertCurrencyToSymbol = (currency) => {
        console.log(currency)
        let symbol = '';
        CrrencySymbols.map((curr) => {
            if (curr.name == currency) {
                symbol = curr.symbol
            }
        })
        return symbol;
    }

    const totalValue = (total, value) => {
        return Number(total) + Number(value);
    }

    const titleCase = (str) => str.toLowerCase().split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    PoDataModel?.poItems.forEach(item => {
        const flagSet = new Set()
        sizeRequired = (item.itemSubCategory.itemSubCategory == "Pouch" || "Carton") ? false : true
        if (sizeRequired == true) {
            flagSet.add(true)
        }
    })

    const totalTaxAmount = PoDataModel ? (Math.round(Number(PoDataModel?.poItems.reduce((currentValue, currentObject) => (currentObject.isActive) ? totalValue(currentValue, currentObject.taxAmount) : 0, 0)))) : null


let roundedTotal;

// Calculate the round-off value
let roundOff;


    return (
        <>
        <style>
            {
                `
                .taa-b{
                border-left:1px solid black;
                padding: 5px;
                text-align:left;
                }`
            }
            </style> 
            <Card
            title={<span style={{ color: 'white' }}>Purchase Order</span>}
            style={{ textAlign: 'center' }}
            headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
            extra={<Button onClick={props.printOrder} className='noprint' style={{ float: 'right', backgroundColor: '#69c0ff' }}><span style={{ color: 'white' }}><PrinterOutlined /> Print</span></Button>}
        ><div>
            <html>
                <body id='printme'>
                {/* <div style={{ display: 'flex',height:"80px" }}>
                <div style={{ paddingRight: '20px' }}>
    <img src={logo} style={{ width: '100px', height: 'auto' }} />
  </div>
                    <div style={{ paddingLeft:'340px'}}><h1>{PoDataModel?.unitinfo?.company}</h1></div>
                    </div>
                    <div style={{ textAlign: 'center' }}>{PoDataModel?.deliveryAddressInfo?.villageName?.toUpperCase()},</div>
                    <div>{PoDataModel?.deliveryAddressInfo?.distirctName?.toUpperCase()},{PoDataModel?.deliveryAddressInfo?.mandalName?.toUpperCase()},</div>
                  

  <div style={{ textAlign: "center" }}>
    {PoDataModel?.deliveryAddressInfo?.postalCode?.toUpperCase()}, {PoDataModel?.deliveryAddressInfo?.stateName?.toUpperCase()}. {PoDataModel?.deliveryAddressInfo?.countryName?.toUpperCase()}
  </div> */}


<br/><br/><br/> <p style={{textAlign:"center"}}> <b>Purchase Order</b></p> 
{/* --------------------------new--------------------------- */}
<table  style={{width:"100%",lineHeight:"1.6",border:'1px solid black'}}>
    <tr>
        <td rowSpan={3} colSpan={2} className={'ta-b'} >
        <h4>Invoice To</h4>
         {(PoDataModel?.billingAddressInfo?.unitcodeId == 12) ? <><p style={{ width: '60%' }}><b>{'Neeli Sea Foods Pvt. Ltd'}</b></p></>:
        <><p><b>{PoDataModel?.deliveryAddressInfo?.company}</b><br />
                <div>Shrimp Process Division </div>
      {PoDataModel?.deliveryAddressInfo?.villageName?.toUpperCase()}, {PoDataModel?.deliveryAddressInfo?.mandalName?.toUpperCase()} {PoDataModel?.deliveryAddressInfo?.distirctName?.toUpperCase()},  {PoDataModel?.deliveryAddressInfo?.stateName?.toUpperCase()}-{PoDataModel?.deliveryAddressInfo?.postalCode?.toUpperCase()},{PoDataModel?.deliveryAddressInfo?.countryName?.toUpperCase()}</p></>}
        <div> GSTIN/UIN:
            {exporterData?.GSTNumber}
            </div> 
        <div> State Name : {PoDataModel?.deliveryAddressInfo?.stateName?.toUpperCase()},code:
            {exporterData?.stateCode}
            </div>
       <div>E-mail : accounts@bmrgroups.org</div>
        </td>
        <td  colSpan={3} className={'ta-b'} >
            <h4>
                Voucher No:<br/>
                {`${PoDataModel?.purchaseOrderNo}`}

            </h4>
        </td>
        <td colSpan={3} className={'ta-b'} >
            Dated:
            <h4><b>{moment(PoDataModel?.purchaseOrderDate).format('DD-MMM-YYYY')}</b>
            </h4>

        </td>
        

    </tr>
    <tr>
  
        <td colSpan={3} className={'ta-b'} >

        </td>
        <td colSpan={3} className={'ta-b'} >
            <h4>Mode/Terms of Payment </h4>
           <b> {PoDataModel?.paymentTermsName}</b>
        </td>
    </tr>
    <tr>
        <td colSpan={3} className={'ta-b'} >
            Reference No. & Date.<br></br>
            <b>{`${PoDataModel?.purchaseOrderNo}`}-{moment(PoDataModel?.purchaseOrderDate).format('DD-MMM-YYYY')}</b>


        </td>
        <td colSpan={3} className={'ta-b'} >
            Other References
        </td>
    </tr>

<tr  >
    <td colSpan={2}  rowSpan={2}  className={'ta-b'} >
        
            Supplier(Bill Form)
        
    <p >
    <h4>
       <b> {PoDataModel?.vendor?.vendorName} </b><br />
        {PoDataModel?.vendorInfo?.street ? PoDataModel?.vendorInfo?.street + ", " : ''}
        {PoDataModel?.vendorInfo?.apartment ? PoDataModel?.vendorInfo?.apartment + ", " : ''}
        {PoDataModel?.vendorInfo?.city ? PoDataModel?.vendorInfo?.city + ", " : ''}
        {PoDataModel?.vendorInfo?.postalCode ? PoDataModel?.vendorInfo?.postalCode + ", " : ''}
        {/* Uncomment below if needed */}
        {/* Attn: {PoDataModel?.vendorInfo?.contactPerson ? PoDataModel?.vendorInfo?.contactPerson : ''} */}
      </h4>    </p>               <div> GSTIN/UIN: {PoDataModel?.vendorInfo?.gstNumber}</div>
      <div> State Name:{PoDataModel?.vendorInfo?.stateName},code: {exporterData?.stateCode}</div>
                       

    </td>
   
    <td colSpan={3} className={'ta-b'} >
        Dispatched through:
        <h4> <b>By Road</b></h4>
    </td>
    <td colSpan={3} className={'ta-b'} >
        Destination:
        {/* <h5><b>{PoDataModel?.billingAddressInfo?.villageName?.toUpperCase()}</b></h5> */}
        <h5><b>Damavaram</b></h5>
    </td>
</tr>
<tr>
    <td colSpan={6} className={'ta-b'} >
        Terms Of Delivery<br></br>
       
        
               <b>{PoDataModel?.deliveryTerms} </b>
         
        
    </td>
</tr>


<tr style = {{textAlign :'center'}}>
                    <th className={'ta-b'} style = {{textAlign :'center'}} > Sno</th>
                    <th colSpan={1} style = {{textAlign :'center'}}
                                className={'ta-b'}>
                                Description of Goods
                            </th>
                            <th colSpan={1} style = {{textAlign :'center',width:"120px"}}
                                className={'ta-b'}>
                                Due on
                            </th>
                           
                            <th colSpan={1} style = {{textAlign :'center',width:"90px"}}
                                className={'ta-b'}>
                                Quantity

                            </th>
                            <th colSpan={1} className={'ta-b'} style = {{textAlign :'center',width:"90px"}} >
                                Rate
                            </th>
                            <th colSpan={1}  className={'ta-b'} style = {{textAlign :'center'}}>
                                Per

                            </th>
                            <th colSpan={1}  className={'ta-b'} style = {{textAlign :'center'}} >
                                Disc%
                                
                            </th>
                           
                            <th colSpan={1} className={'ta-b'}  style = {{textAlign :'center'}}>
                                Amount
                            </th>
                    </tr>
                
   
                    {
                       PoDataModel?.poItems.map((item, index) => {
                        if (item.isActive) {
                            let itemNameParts = item.item.itemName?.split('/');
                            totalQuantity = totalQuantity + Number(item.quantity);
                            
                            const totalAmounts = item.quantity !== null && item.unitPrice !== null
                                ? item.discountPercentage !== null
                                    ? (item.quantity * item.unitPrice) - (item.quantity * item.unitPrice * (item.discountPercentage / 100))
                                    : item.quantity * item.unitPrice
                                : 0;
                    
                            Totalsum += totalAmounts;
                            console.log(Totalsum, "Totalsum");
                    
                            // Calculate SGST and CGST for each item based on tax percentage
                            const totalTaxAmount = item.tax.taxPercentage
                                ? (totalAmounts * item.tax.taxPercentage) / 100
                                : 0;
                    
                            console.log(`Total tax for item: ${totalTaxAmount}`);
                    
                            // Distribute tax equally between SGST and CGST
                            const itemSgst = totalTaxAmount / 2;
                            const itemCgst = totalTaxAmount / 2;
                    
                            sgst += itemSgst;
                            cgst += itemCgst;
                    
                            let finalCalculation = 0;
                            finalCalculation += Totalsum + sgst + cgst;
                    
                            return (
                                <tr className='css-serial'>
                                    <td className={'taa-b'} id='count1'>{index + 1}</td>
                                    <td colSpan={1} className={`taa-b stylesInfo`} style={{ fontSize: '1.17em', textAlign: 'left', borderBottom: "none" }}>
                                        {/* {(itemNameParts?.length > 2) ? (itemNameParts.map((itemPart, index) => {
                                            let name = (index === 1 ? <b>{itemPart}</b> : itemPart);
                                            if ((itemNameParts?.length - index) != 1 && index != 1) {
                                                name += '/';
                                            }
                                            if (index === 2) {
                                                name = "/" + name;
                                            }
                                            return name;
                                        })) : item.item.itemName}
                                        - {item.item.product}&nbsp;{item.item.foodType}&nbsp;{item.item.valAddFour} */}
                                        {item.item.itemName}
                                    </td>
                                    <td style={{ textAlign: 'right', borderBottom: "none" }} colSpan={1} className={'taa-b'}>
                                        {moment(PoDataModel?.expectedDeliveryDate).format('DD-MMM-YYYY')}
                                    </td>
                                    <td colSpan={1} style={{ textAlign: 'right', borderBottom: "none" }} className={'taa-b'}>
                                        {item.quantity}{" "} {item.item.uomName}
                                    </td>
                                    {/* {(PoDataModel?.vendor.priceNeeded == GlobalStatus.YES) ? */}
                                        <td style={{ textAlign: 'right' }} className={'taa-b'}>
                                            {convertCurrencyToSymbol(PoDataModel?.vendor.currency)} {Number(item.unitPrice)}
                                        </td> 
                                        {/* : ""} */}
                                    <td style={{ textAlign: 'right' }} className={'taa-b'}>
                                    {item.item.uomName}
                                    </td>
                                    <td className={'taa-b'} style={{ textAlign: 'right' }}>
                                        {item.discountPercentage}
                                    </td>
                                    <td colSpan={1} style={{ textAlign: 'right', borderRight: "1px solid black" }} className={'taa-b'}>
                                        {totalAmounts?.toFixed(2)}
                                    </td>
                                </tr>
                            );
                        }
                    })
                    
                        }
                    

                        {
                            
                            
                        }
                        

                        <tr >
                            <td className={'taa-b'}>

                            </td>
                            
                        <td  className={'taa-b'} style={{ textAlign: 'right',}}><b>Input CGST-Goods</b></td>
                        <td className={'taa-b'}></td>
                        <td className={'taa-b'}></td>
                        <td className={'taa-b'}></td>
                        <td className={'taa-b'}></td>
                        <td className={'taa-b'}></td>
                        <td   className={'taa-b'} style={{ textAlign: 'right',borderRight:'1px solid black'}}>
                           <b> {sgst.toFixed(2)}</b>
                        </td>
   
                        </tr>
                        <tr  className={'taa-b'}>
                            <td className={'taa-b'}>

                            </td >
                        <td style={{ textAlign: 'right', borderRight: '1px solid #000' } }className={'taa-b'}><b>Input SGST-Goods</b></td>
                        <td className={'taa-b'}></td>
                        <td className={'taa-b'}></td>
                        <td className={'taa-b'}></td>
                        <td className={'taa-b'}></td>
                        <td className={'taa-b'}></td>
                        <td style={{ textAlign: 'right', borderRight:'1px solid black'}} className={'taa-b'}>
                           <b> {cgst.toFixed(2)}</b>
                        </td>
                            
                        </tr>
                        <tr>
                            <td className={'ta-b'}>

                            </td>
                            <td className={'ta-b'} style={{ textAlign: 'right' }} >
                                <b>Total</b>
                            </td>
                            <td className={'ta-b'}>

                            </td>
                            <td className={'ta-b'} style={{ textAlign: 'right' }} >
                                 <b> {totalQuantity}</b>

                           </td ><td className={'ta-b'}></td>

                                <td className={'ta-b'}></td><td className={'ta-b'}></td><td className={'ta-b'} style={{ textAlign: 'right' }} >
                                <b>₹{(Number(sgst) + Number(cgst) + Totalsum).toLocaleString('en-IN')}</b>
                               
                                </td>
                            
                        </tr>
                    

                        {/* <tr>
                            <td colSpan={9} style={{ textAlign: 'left' }} className={'ta-b'}>
                            <b> Amount Chargable (in words)</b>
                           
                           <br></br>
                              
                              <b>{PoDataModel?.vendor?.currency == 'INR' ? ''+(PoDataModel?.vendor?.currency?.toUpperCase())+'':''} {PoDataModel?.vendor?.currency == 'INR' ? titleCase(numberToWords(Number(Math.round(Number(Number(Number(sgst)+ Number(cgst) + Totalsum)))))) : (new ToWords({
                              localeCode: 'en-US',
                              }).convert(Number(Number(Number(sgst)+ Number(cgst) + Totalsum).toFixed(3)),{ currency: true, ignoreZeroCurrency: true }))} {PoDataModel?.vendor?.currency == 'INR' ? 'Only' : ''}</b>
                              <td></td>
                              <td></td>
                        <td></td>
                        <td></td>
                        <td></td> 
                        <h5 style={{ width: "1425px", marginTop: "-47px",textAlign:"right"}}>E. & O.E</h5>
                            <br/>
                            <br/> 
                            <br/> 
                            <br/> 
                            <tr><td rowSpan={2}>
                            <h3><u>Decleration</u></h3>  
                            
                            <h5>If the Material is not supplied with in the stipulated period,<br/>
                                it is a buyer Option to cancel or extend the purhase order<br/>
                                delivery time</h5>
                            <h5> If  any rejection found by us in quality/size of goods, <br/>
                                the rejected goods will be  return to you for replacement at your cost</h5>
                                </td>
                           

<td rowSpan={6}>
<h5 className={'ta-b'} style={{ alignContent: 'flex-end', marginLeft: '810px', marginTop: '-77px', textAlign: 'right' }}>
  {PoDataModel?.unitinfo?.company !== "BMR INDUSTRIES PRIVATE LIMITED" ? ' for BMR EXPORTS' : ' for BMR INDUSTRIES PRIVATE LIMITED'} <br/><br/><br/>
  Authorised Signatory
</h5> 
</td>
</tr>

                            </td>
                        </tr> */}
                        <tr>
                            <td colSpan={7} style={{textAlign:'start',borderLeft:'1px solid black'}} >
                                <b> Amount Chargable (in words)</b>
                                <br></br>
                                <b>{PoDataModel?.vendor?.currency == 'INR' ? ''+(PoDataModel?.vendor?.currency?.toUpperCase())+'':''} {PoDataModel?.vendor?.currency == 'INR' ? titleCase(numberToWords(Number(Math.round(Number(Number(Number(sgst)+ Number(cgst) + Totalsum)))))) : (new ToWords({
                                localeCode: 'en-US',
                                }).convert(Number(Number(Number(sgst)+ Number(cgst) + Totalsum).toFixed(3)),{ currency: true, ignoreZeroCurrency: true }))} {PoDataModel?.vendor?.currency == 'INR' ? 'Only' : ''}</b>
                            </td>
                            <td style={{ textAlign:"right",borderRight:'1px solid black',padding:'5px'}}>
                                <div >E. & O.E</div>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={8}  style={{textAlign:'start'}} className={'ta-b'}>
                            <div><h3><u>Declaration</u></h3></div>   
                            
                            <div>If the Material is not supplied with in the stipulated period,<br/>
                                it is a buyer Option to cancel or extend the purhase order<br/>
                                delivery time</div>
                            <div> If  any rejection found by us in quality/size of goods, <br/>
                                the rejected goods will be  return to you for replacement at your cost</div>
 
                                <div className={'ta-b'} style={{ alignContent: 'flex-end', marginLeft: '500px', marginTop: '-77px', textAlign: 'right' }}>
                                {PoDataModel?.unitinfo?.company !== "BMR INDUSTRIES PRIVATE LIMITED" ?
 (
                                <span>
                                    <span style={{ textTransform: 'lowercase' }}>for</span> BMR EXPORTS
                                </span>
                            ) : (
                                <span>
                                    <span style={{ textTransform: 'lowercase' }}>for </span><span style={{ textTransform: 'uppercase' }}>BMR INDUSTRIES PRIVATE LIMITED</span>
                                </span>
                            )}
                              <br/><br/><br/>
                              <span style={{ textTransform: 'capitalize' }}>authorised signatory</span>
                            </div>

                            </td>
                            
                        </tr>

</table>
<h5 style={{textAlign:"center"}}> SUBJECT TO NELLORE JURISDICTION</h5>
<h5 style={{textAlign:"center"}}> This is a Computer Generated Document</h5>
            
                </body>
            </html>
            </div>
        </Card>
            </>
        
     

    );
}

export default PoPrint;